import { Link } from 'react-router-dom';
import { comics, rankByViews } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotSerials() {
  const hot = comics.filter((c) => c.hot);
  const ranked = [...hot].sort((a, b) => b.rating - a.rating);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-500">
            <i className="ri-fire-fill"></i> 编辑推荐
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">热门连载</h2>
          <p className="mt-2 text-sm text-foreground-500">人气与口碑双高的原版作品，追更就选它们</p>
        </div>
        <Link
          to="/comics"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-400 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {ranked.map((c, i) => (
          <div key={c.id} className="group relative">
            <div className="absolute -top-3 -left-1 z-10 flex items-center gap-1.5 rounded-lg bg-gradient-to-br from-accent-500 to-primary-500 px-2.5 py-1 text-sm font-bold text-background-50 shadow-lg">
              <i className="ri-trophy-fill text-xs"></i>
              {i + 1}
            </div>
            <ComicCard comic={c} />
          </div>
        ))}
      </div>

      {/* ranking list */}
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        {[0, 1].map((half) => (
          <div
            key={half}
            className="rounded-xl bg-background-100 p-5 md:p-6 border border-background-200/60"
          >
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg text-foreground-950">
                {half === 0 ? '综合人气榜' : '高分口碑榜'}
              </h3>
              <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 whitespace-nowrap">
                实时更新
              </span>
            </div>
            <ul className="mt-4 flex flex-col gap-1">
              {half === 0
                ? rankByViews.map((item, i) => (
                    <RankRow key={item.id} rank={i + 1} item={item} />
                  ))
                : [...ranked].sort((a, b) => b.rating - a.rating).map((c, i) => (
                    <li
                      key={c.id}
                      className="group flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-background-200"
                    >
                      <span
                        className={`w-6 text-center font-heading text-lg ${
                          i < 3 ? 'text-accent-500' : 'text-foreground-500'
                        }`}
                      >
                        {i + 1}
                      </span>
                      <img src={c.cover} alt={c.title} title={c.title} loading="lazy" className="h-14 w-10 rounded-md object-cover" />
                      <div className="flex-1 min-w-0">
                        <Link to={`/comic/${c.id}`} className="block truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-500">
                          {c.title}
                        </Link>
                        <p className="mt-0.5 truncate text-xs text-foreground-500">
                          {c.author} · {c.status}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="flex items-center justify-end gap-1 text-sm text-accent-500">
                          <i className="ri-star-fill text-xs"></i> {c.rating}
                        </p>
                        <p className="mt-0.5 text-xs text-foreground-500">{c.views}</p>
                      </div>
                    </li>
                  ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

interface RankRowProps {
  rank: number;
  item: { id: string; title: string; cover: string; rating: number; views: string; change: string };
}

function RankRow({ rank, item }: RankRowProps) {
  return (
    <li className="group flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-background-200">
      <span
        className={`w-6 text-center font-heading text-lg ${
          rank <= 3 ? 'text-accent-500' : 'text-foreground-500'
        }`}
      >
        {rank}
      </span>
      <img src={item.cover} alt={item.title} title={item.title} loading="lazy" className="h-14 w-10 rounded-md object-cover" />
      <div className="flex-1 min-w-0">
        <Link to={`/comic/${item.id}`} className="block truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-500">
          {item.title}
        </Link>
        <p className="mt-0.5 text-xs text-foreground-500">人气 {item.views}</p>
      </div>
      <span
        className={`flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-xs font-semibold ${
          item.change.startsWith('↑')
            ? 'bg-primary-500/15 text-primary-500'
            : 'bg-secondary-100 text-secondary-900'
        } whitespace-nowrap`}
      >
        {item.change.startsWith('↑') ? <i className="ri-arrow-up-line text-[10px]"></i> : null}
        {item.change}
      </span>
    </li>
  );
}